import { render } from "./CustomerCreativity.vue?vue&type=template&id=9fd74c56&scoped=true"
import script from "./CustomerCreativity.vue?vue&type=script&lang=js"
export * from "./CustomerCreativity.vue?vue&type=script&lang=js"

import "./CustomerCreativity.vue?vue&type=style&index=0&id=9fd74c56&scoped=true&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fd74c56"]])

export default __exports__